module.exports = __webpack_public_path__ + "img/foto 3 Incineração e mudas (1).eb5247e7.webp";